import React from "react";
import Toolbar from "./Toolbar";
import HeaderAccueil from "./HeaderAccueil";
import Header from "./Header";
import { IndexedDB } from "./functions/IndexedDb";
import Menu from "./Menu";
import { IndexedDBOffline } from "../service/indexed-db-offline";
import { PushOnline } from "./functions/PushOnline";
import tingle from "tingle.js";
import Dexie from "dexie";
import { db } from "../service/dbservice";
import { SyncSW } from "./functions/SyncSW";
import { CheckBrowser } from "./functions/CheckBrowser";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.value = "";
    this.informations = "";
    this.incImg = 1;
    this.state = {
      chargement: "",
    };
  }
  componentDidMount() {
    CheckBrowser((result) => {
      this.informations = result;
    });
    console.log(this.informations);
    if (localStorage.getItem("infosUser")) {
      if (navigator.onLine) {
        if (
          !Dexie.exists("moquetMediatheque") ||
          !localStorage.getItem("synchroOk")
        ) {
          var modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ["overlay", "button", "escape"],
            closeLabel: "Fermer",
            cssClass: ["c-tingle__modal"],
            beforeClose: function () {
              // here's goes some logic
              // e.g. save content before closing the modal
              return true; // close the modal
            },
          });

          modal.setContent(
            '<div class="c-form__modal"><p><strong class="msgModal">Synchronisation des données en cours...</strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
          );
          /*document
            .querySelector(".c-msg__synchro")
            .append(this.informations.device + "<br />");
          document
            .querySelector(".c-msg__synchro")
            .append(this.informations.browser);*/
          /*PushOnline(result => {
              console.dir(result);
              if (result === "ok") {
                IndexedDB(result => {
                  modal.setContent(
                      '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                    );
                    setTimeout(()=> {
                        modal.close();
                        window.location.reload();
                    },3000)
                  
                });
              }
            });*/

          PushOnline((result) => {
            db.synchroImg
              .where("rep")
              .equals("ok")
              .delete()
              .then((deleteCount) => {});

            if (result === "ok") {
              CheckBrowser((result) => {
                this.informations = result;
                IndexedDB((result) => {
                  if (
                    (this.informations.browser === "Chrome" &&
                      this.informations.device === "iOS") ||
                    (this.informations.browser === "Firefox" &&
                      this.informations.device === "iOS")
                  ) {
                    this.props.remonterEtat({
                      tabProduits: result.produits,
                      tabCouleurs: result.couleurs,
                      familles: result.familles,
                      regions: result.regions,
                      departements: result.departements,
                    });
                    this.setState({ chargement: "ok" });
                    modal.setContent(
                      '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                    );
                    setTimeout(() => {
                      var btnClose = document.querySelector(
                        "tingle-modal__close"
                      );
                      db.tabImg.clear();
                      if (btnClose) {
                        btnClose.click();
                      } else {
                        modal.close();
                      }

                      if (window.location.hash !== "") window.location.reload();
                    }, 2000);
                  } else {
                    try {
                      //serviceWorker.register();
                      navigator.serviceWorker
                        .getRegistration("https://dm-book.daniel-moquet.com/")
                        .then((registration) => {
                          console.dir(registration);
                          var swActive = setInterval(() => {
                            if (registration.active) {
                              if (navigator.serviceWorker.controller) {
                                clearInterval(swActive);
                                navigator.serviceWorker.controller.postMessage(
                                  "synchro_img"
                                );
                                var intervalSync = setInterval(() => {
                                  db.synchroImg
                                    .where("rep")
                                    .equals("ok")
                                    .toArray()
                                    .then((reponses) => {
                                      if (reponses.length > 0) {
                                        clearInterval(intervalSync);
                                        CheckBrowser((result) => {
                                          this.informations = result;
                                          if (
                                          this.informations.browser === "Chrome"
                                        ) {
                                          SyncSW((result) => {
                                            /*if(result === 'ok'){
                                          modal.setContent(
                                            '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                                          ); 
              
                                        }*/
                                          });
                                        }
                                        });
                                        
                                      }
                                    });
                                }, 500);
                              }
                            }
                          }, 3000);
                        });
                    } catch (error) {
                      document.querySelector(".c-msg__synchro").append(error);
                      alert(error);
                    }

                    this.props.remonterEtat({
                      tabProduits: result.produits,
                      tabCouleurs: result.couleurs,
                      familles: result.familles,
                      regions: result.regions,
                      departements: result.departements,
                    });
                    this.setState({ chargement: "ok" });
                    modal.setContent(
                      '<div class="c-form__modal"><p><strong>Synchronisation des médias en cours... <span class="c-nb-images"></span></strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="u-cache c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
                    );
                    var xInfoImg = setInterval(function () {
                      db.nbImg
                        .orderBy("id")
                        .last()
                        .then((elem) => {
                          if (elem.id !== undefined) {
                            db.nbImgUpload
                              .orderBy("id")
                              .last()
                              .then((elemUpload) => {
                                if (elemUpload.id !== undefined) {
                                  modal.setContent(
                                    '<div class="c-form__modal"><p><strong>Synchronisation des médias en cours... <span class="c-nb-images">' +
                                      elemUpload.rep +
                                      "/" +
                                      elem.rep +
                                      '</span></strong></p><div class="c-mediatheque__loading"><svg xmlns="http://www.w3.org/2000/svg" class="svg__loading" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" > <circle cx="84" cy="50" r="3.30692" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="0.3846153846153846s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="fill" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#d54d4d;#00a94f;#f8b26a;#dc7965;#d54d4d" begin="0s" ></animate> </circle> <circle cx="16" cy="50" r="6.69308" fill="#d54d4d"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s" ></animate> </circle> <circle cx="38.7565" cy="50" r="10" fill="#dc7965"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.3846153846153846s" ></animate> </circle> <circle cx="72.7565" cy="50" r="10" fill="#f8b26a"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.7692307692307692s" ></animate> </circle> <circle cx="16" cy="50" r="0" fill="#00a94f"> <animate attributeName="r" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> <animate attributeName="cx" repeatCount="indefinite" dur="1.5384615384615383s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-1.1538461538461537s" ></animate> </circle> </svg></div><div class="u-cache c-msg__synchro">Synchronisation des réalisations : <span data-type="totalReal">0</span>%<input type="hidden" data-input="totalReal" value="0" /><br />Synchronisation des produits : <span data-type="totalProduits">0</span>%<input type="hidden" data-input="totalProduits" value="0"/><br />Synchronisation de l\'organigrammme : <span data-type="totalOrga">0</span>%<input type="hidden" data-input="totalOrga" value="0" /><br />Synchronisation du contenu : <span data-type="totalContenu">0</span>%<input type="hidden" data-input="totalContenu" value="0" /><!--<br />Récupération des images : <span data-type="totalImages">0</span>%<input type="hidden" data-input="totalImages" value="0" />--></div></div>'
                                  );
                                  this.value = elemUpload.rep;
                                }
                              });
                          }
                        });
                    }, 2000);
                    var x = setInterval(function () {
                      db.synchroImg
                        .where("rep")
                        .equals("okSync")
                        .toArray()
                        .then((reponses) => {
                          if (reponses.length > 0) {
                            modal.setContent(
                              '<div class="c-form__modal"><p><strong>Synchronisation effectuée</strong></p></div>'
                            );
                            clearInterval(x);
                            clearInterval(xInfoImg);
                            db.nbImg.clear();
                            db.nbImgUpload.clear();
                            db.synchroImg
                              .where("rep")
                              .equals("okSync")
                              .delete()
                              .then((deleteCount) => {
                                db.synchroImg
                                  .where("rep")
                                  .equals("ok")
                                  .delete();
                                setTimeout(() => {
                                  console.log("ici on ferme modal");
                                  console.dir(modal);
                                  var btnClose = document.querySelector(
                                    "tingle-modal__close"
                                  );
                                  if (btnClose) {
                                    btnClose.click();
                                  } else {
                                    modal.close();
                                  }

                                  if (window.location.hash !== "")
                                    window.location.reload();
                                }, 2000);
                              });
                          }
                        });
                    }, 3000);
                  }

                  //}
                });
              });
            }
          });
          modal.open();
        } else {
          IndexedDBOffline((result) => {
            this.props.remonterEtat({
              tabProduits: result.produits,
              tabCouleurs: result.couleurs,
              familles: result.familles,
              regions: result.regions,
              departements: result.departements,
            });
            this.setState({ chargement: "ok" });
          });
        }
      } else {
        IndexedDBOffline((result) => {
          this.props.remonterEtat({
            tabProduits: result.produits,
            tabCouleurs: result.couleurs,
            familles: result.familles,
            regions: result.regions,
            departements: result.departements,
          });
          this.setState({ chargement: "ok" });
        });
      }
      localStorage.setItem("connecte", "ok");
      localStorage.setItem("synchroOk", "ok");
    }
  }

  render() {
    return (
      <div className="l-global">
        <Header title={"DM Book - médiathèque"}/>
        <Toolbar buttonReal="true" historique={this.props.history} />

        {this.props.tabProduits.length > 0 && (
          <Menu
            className="l-home__rubriques l-menu__general js__menu"
            produits={this.props.tabProduits}
          />
        )}

        <div className="l-tpl__split-2-lines">
          <HeaderAccueil />
          {this.state.chargement === "ok" && (
            <Menu
              className="l-home__rubriques"
              produits={this.props.tabProduits}
            />
          )}
        </div>
      </div>
    );
  }
}
export default Home;
